import { createContext, useContext, useState } from "react";

const safeGetUser = () => {
    const raw = localStorage.getItem("user");
    if (!raw || raw === "undefined" || raw === "null") return {};
    try {
        return JSON.parse(raw);
    } catch {
        return {};
    }
};

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user] = useState(safeGetUser());

    const administracionId = parseInt(localStorage.getItem("administracionId") || user.administracionId || 1, 10);
    const rolId = parseInt(localStorage.getItem("rolId") || user.rolId || 1, 10);
    const usuarioId = user.usuarioId ?? user.id ?? null;

    return (
        <AuthContext.Provider value={{ user, administracionId, rolId, usuarioId }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
